import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { UpdateBanner } from "@/components/UpdateBanner";
import { AuthProvider } from "@/context/AuthContext";
import { RefreshProvider, RefreshableRoutes } from "@/lib/refresh";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import OutlookAddin from "@/pages/OutlookAddin";
import EventVisit from "@/pages/EventVisit";
import ClientRequest from "@/pages/ClientRequest";
import TrackRequest from "@/pages/TrackRequest";
import Events from "@/pages/Events";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import RFQList from "@/pages/RFQList";
import RFQDetail from "@/pages/RFQDetail";
import SupplierQuotePage from "@/pages/SupplierQuotePage";
import LogisticsDashboard from "@/pages/LogisticsDashboard";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Suppliers from "@/pages/Suppliers";
import SupplierDetail from "@/pages/SupplierDetail";
import Team from "@/pages/Team";
import Ideas from "@/pages/Ideas";
import DeletedVersions from "@/pages/DeletedVersions";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Settings from "@/pages/Settings";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import SupplierPoDetail from "@/pages/SupplierPoDetail";
import OrderDocEdit from "@/pages/OrderDocEdit";
import Opportunities from "@/pages/Opportunities";
import ServiceCenter from "@/pages/ServiceCenter";
import Catalog from "@/pages/Catalog";
import StockLevels from "@/pages/StockLevels";
import Approvals from "@/pages/Approvals";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <UpdateBanner />
      <AuthProvider>
        <BrowserRouter>
          <RefreshProvider>
          <RefreshableRoutes>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/outlook-addin" element={<OutlookAddin />} />
            <Route path="/visit/:code" element={<EventVisit />} />
            <Route path="/request" element={<ClientRequest />} />
            <Route path="/track" element={<TrackRequest />} />
            <Route path="/t/:ref" element={<TrackRequest />} />
            <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/opportunities" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
            <Route path="/approvals/:id" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
            <Route path="/service" element={<ProtectedRoute><ServiceCenter /></ProtectedRoute>} />
            <Route path="/catalog" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
            <Route path="/catalog/stock" element={<ProtectedRoute><StockLevels /></ProtectedRoute>} />
            <Route path="/inventory" element={<Navigate to="/catalog" replace />} />
            <Route path="/rfqs" element={<ProtectedRoute><RFQList /></ProtectedRoute>} />
            <Route path="/rfqs/:id" element={<ProtectedRoute><RFQDetail /></ProtectedRoute>} />
            <Route path="/rfqs/:id/quotes/:supplierId" element={<ProtectedRoute><SupplierQuotePage /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
            <Route path="/orders/som-po/:id" element={<ProtectedRoute><SupplierPoDetail /></ProtectedRoute>} />
            <Route path="/orders/docs/:docId" element={<ProtectedRoute><OrderDocEdit /></ProtectedRoute>} />
            <Route path="/logistics" element={<ProtectedRoute><LogisticsDashboard /></ProtectedRoute>} />
            <Route path="/logistics/shipment/:id" element={<ProtectedRoute><ShipmentDetail /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
            <Route path="/clients/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
            <Route path="/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/suppliers/:id" element={<ProtectedRoute><SupplierDetail /></ProtectedRoute>} />
            <Route path="/industries" element={<ProtectedRoute><Industries /></ProtectedRoute>} />
            <Route path="/industries/:value" element={<ProtectedRoute><IndustryDetail /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            <Route path="/deleted-versions" element={<ProtectedRoute><DeletedVersions /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/ideas" element={<ProtectedRoute><Ideas /></ProtectedRoute>} />
          </Routes>
          </RefreshableRoutes>
          </RefreshProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
